var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.803 3.33333C10.803 1.49238 12.3022 0 14.1515 0C16.0008 0 17.5 1.49238 17.5 3.33333C17.5 5.17428 16.0008 6.66667 14.1515 6.66667C13.2177 6.66667 12.3738 6.28596 11.7671 5.67347L7.13167 8.82955C7.17452 9.04248 7.19697 9.26245 7.19697 9.48718C7.19697 9.93221 7.10904 10.3576 6.94959 10.7464L12.0323 14.0858C12.6092 13.6161 13.3473 13.3333 14.1515 13.3333C16.0008 13.3333 17.5 14.8257 17.5 16.6667C17.5 18.5076 16.0008 20 14.1515 20C12.3022 20 10.803 18.5076 10.803 16.6667C10.803 16.1845 10.9062 15.7255 11.0917 15.3111L6.05007 11.9987C5.46196 12.5098 4.6916 12.8205 3.84848 12.8205C1.99917 12.8205 0.5 11.3281 0.5 9.48718C0.5 7.64623 1.99917 6.15385 3.84848 6.15385C4.9119 6.15385 5.85853 6.64725 6.47145 7.41518L10.9639 4.35642C10.8594 4.03359 10.803 3.6896 10.803 3.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d8225386cbdfd45e573a9d70e7b58d85.svg";
export { ForwardRef as ReactComponent };